import { computed } from 'vue';
export function useWidgetConfig(config) {
    const configFlag = (name, getter) =>
        computed(() => config?.[name] && !!getter())

    return { configFlag }
}